/* =============================================
   IVY THEME — JavaScript
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {
  // Nav scroll
  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('nav--scrolled', window.pageYOffset > 50);
    }, { passive: true });
  }

  // Scroll reveal
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) e.target.classList.add('reveal--visible');
      });
    }, { threshold: 0.02, rootMargin: '0px 0px 80px 0px' });
    revealEls.forEach(el => revealObs.observe(el));
  }

  // Counter animation
  const counters = document.querySelectorAll('.metric__value[data-count]');
  if (counters.length) {
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        const target = parseFloat(el.dataset.count);
        const isDecimal = target % 1 !== 0;
        const isLarge = target >= 100;
        const suffix = el.dataset.suffix || '';
        const duration = 2000;
        const start = performance.now();

        function tick(now) {
          const p = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          const val = eased * target;

          if (isDecimal) el.textContent = val.toFixed(1) + suffix;
          else if (isLarge) el.textContent = Math.round(val).toLocaleString() + '+' + suffix;
          else el.textContent = Math.round(val) + suffix;

          if (p < 1) requestAnimationFrame(tick);
        }

        requestAnimationFrame(tick);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.5 });
    counters.forEach(el => counterObs.observe(el));
  }

  // Smooth anchor scroll
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      e.preventDefault();
      const t = document.querySelector(href);
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
